var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-grid-container"},[_c('div',{staticClass:"image-grid"},_vm._l((_vm.allImages),function(image,index){return _c('div',{key:index,staticClass:"image-item"},[_c('img',{attrs:{"src":image,"alt":'Image ' + (index + 1)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }